import { ReactNode } from 'react';

interface StatusPageProps {
  title?: string;
  message?: string;
  children?: ReactNode;
  variant?: 'default' | 'error' | 'success' | 'warning';
  maxWidth?: 'sm' | 'md' | 'lg' | 'xl' | '2xl' | 'full';
}

const variantStyles = {
  default: 'text-primary-600 dark:text-primary-400',
  error: 'text-red-600 dark:text-red-400',
  success: 'text-green-600 dark:text-green-400',
  warning: 'text-yellow-600 dark:text-yellow-400',
};

const maxWidthStyles = {
  sm: 'max-w-sm',
  md: 'max-w-md',
  lg: 'max-w-lg',
  xl: 'max-w-xl',
  '2xl': 'max-w-2xl',
  full: 'max-w-full',
};

export function StatusPage({
  title,
  message,
  children,
  variant = 'default',
  maxWidth = 'md'
}: StatusPageProps) {
  return (
    <div className="min-h-screen bg-primary-50 dark:bg-primary-950 py-24">
      <div className={`container-elegant ${maxWidthStyles[maxWidth]}`}>
        {title && (
          <h1 className="text-2xl font-light tracking-tight text-primary-950 dark:text-white mb-4 text-center">
            {title}
          </h1>
        )}
        {message && (
          <p className={`${variantStyles[variant]} mb-6 text-center`}>
            {message}
          </p>
        )}
        {children}
      </div>
    </div>
  );
}

// Preset variants for common use cases
export function ErrorPage({ message, maxWidth }: { message: string; maxWidth?: StatusPageProps['maxWidth'] }) {
  return (
    <StatusPage
      title="Error"
      message={message}
      variant="error"
      maxWidth={maxWidth}
    />
  );
}

export function LoadingPage({ message = "Loading...", maxWidth }: { message?: string; maxWidth?: StatusPageProps['maxWidth'] }) {
  return (
    <StatusPage
      message={message}
      maxWidth={maxWidth}
    />
  );
}

StatusPage.displayName = 'StatusPage';